export default __webpack_public_path__ + "static/media/ticket.86801a4f.svg";